import { Star } from "lucide-react";

const TRUST_ITEMS = [
  "Chiropractors",
  "Gyms",
  "Physical Therapists",
  "School Athletic Programs",
  "Fitness Events",
  "Races",
];

export const TrustSection = () => {
  return (
    <section className="py-16 bg-[#0a0318] relative">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-white mb-8">
            Trusted by <span className="text-amber-400">Athletes & Organizations</span>
          </h2>
          <div className="flex flex-wrap justify-center gap-6">
            {TRUST_ITEMS.map((item) => (
              <div key={item} className="bg-[#110422]/50 border border-amber-500/20 rounded-full px-6 py-3">
                <p className="text-gray-300 flex items-center gap-2">
                  <Star className="w-4 h-4 text-amber-400" />
                  {item}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
